module.exports = __webpack_public_path__ + "static/media/Artboard3.c6616065.png";